import { useEffect, useState } from 'react';
import { Unlock, Sparkles } from 'lucide-react';

/**
 * Listens for `lounge:level-unlocked` (fired by loungeMeta when a level is
 * cleared and the frontier advances) and shows a quick, self-dismissing
 * "Level X unlocked!" flourish. Mount once in the game host.
 */
export default function LevelUnlockFlourish() {
  const [item, setItem] = useState(null); // { level, show }

  useEffect(() => {
    let hideT, clearT;
    const onUnlock = (e) => {
      const level = e?.detail?.level;
      if (!level) return;
      setItem({ level, show: false });
      requestAnimationFrame(() => setItem((p) => (p ? { ...p, show: true } : p)));
      clearTimeout(hideT);
      clearTimeout(clearT);
      hideT = setTimeout(() => setItem((p) => (p ? { ...p, show: false } : p)), 2200);
      clearT = setTimeout(() => setItem(null), 2600);
    };
    window.addEventListener('lounge:level-unlocked', onUnlock);
    return () => {
      window.removeEventListener('lounge:level-unlocked', onUnlock);
      clearTimeout(hideT);
      clearTimeout(clearT);
    };
  }, []);

  if (!item) return null;

  return (
    <div
      aria-live="polite"
      data-testid="level-unlock-flourish"
      style={{ position: 'fixed', top: 18, left: 0, right: 0, display: 'flex', justifyContent: 'center', zIndex: 9999, pointerEvents: 'none' }}
    >
      <div
        style={{
          transform: item.show ? 'translateY(0) scale(1)' : 'translateY(-16px) scale(0.96)',
          opacity: item.show ? 1 : 0,
          transition: 'opacity 260ms ease, transform 320ms cubic-bezier(.2,.9,.25,1)',
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          padding: '10px 18px',
          borderRadius: 9999,
          background: 'linear-gradient(135deg, rgba(197,160,89,0.96), rgba(212,175,100,0.96))',
          color: '#0B0F1E',
          fontWeight: 800,
          boxShadow: '0 10px 30px rgba(0,0,0,0.35), inset 0 0 0 1px rgba(255,255,255,0.25)',
        }}
      >
        <Unlock size={16} strokeWidth={2.5} />
        <span style={{ fontSize: 14, letterSpacing: 0.3 }}>Level {item.level} unlocked!</span>
        <Sparkles size={15} strokeWidth={2.5} />
      </div>
    </div>
  );
}
